export default "__VITE_ASSET__CYHbTFj8__"